import { App, usePage } from '@inertiajs/inertia-vue3';
import { unserialize } from 'php-serialize';
import moment from 'moment';

// Function

export function isObjectEmpty(data) {
    return !(Object.keys(data).length)
};
export function isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    else {
        return false;
    }
};
export function isChecked(m, v){
    if(Array.isArray(m)) {
        let checked = false;
        m.forEach(el => { if(el == v) checked = true; });

        return checked;
    }
    else {
        let checked = (m == true ? true : (( m == v && v != false) ? true : false) );
        return checked;
    }
};
export function countObject(data) {
    return Object.keys(data).length;
};
export function getLocale() {
    return usePage().props.value.locale;
};
export function inArray(array, val, item) {
    for(let i = 0; i < array.length; i++){
        if(val && array[i][val] == item){
            return true;
        }
        else if(array[i] == item) {
            return true;
        }
    }
    return false
};
export function checkValue(element, value) {
    return element === value;
};
export function isPersonalize(el) {
    let isPersonalize = true;

    if(el.text_engrave == true) isPersonalize = true
    else isPersonalize = false;

    return isPersonalize;
};
export function isBoolean(val) {
    return val === false || val === true;
};
export function textLength(text) {
    return text.length;
};
export function checkStringLength(string, value) {
    return string.length <= value;
};
export function getFullName(val){
    return val.first_name + ' ' + val.last_name;
};
export function getFirstName(val){
    let name = val.split(' ');
    return name[0];
};
export function getLastName(val){
    let name = val.split(' ');
    return name[1];
};
export function getAddress(val){
    return val.street + ' ' + val.building + (val.flat ? ('/' + val.flat) : '');
};
export function getFullAddress(val){
    return val.street + ' ' + val.building + (val.flat ? ('/' + val.flat) : '') + ', ' + val.zip + ' ' + val.city;
};
export function checkError(errors, value) {
    if( errors && (Object.keys(errors).length) && errors.hasOwnProperty(value)) return errors[value];
    else return false;
};
export function isSmaller(val, breakpoint) {
    if(breakpoint >= val) {
        return true;
    } else return false;
};
export function isBigger(val, breakpoint) {
    if(breakpoint < val) {
        return true;
    } else return false;
};
export function isDarkMode(value = null){

    return localStorage.getItem('rqa_darkMode') ? ( localStorage.getItem('rqa_darkMode') == 'true' ? true : false ) : false;
}
export function getUserAvatar(user){
    if(user.image){
        return '/storage/' + user.image.url;
    }
    else return '/images/avatar/' + (user.gender == 'man' ? 'man' : 'female') + '.png'
}
export function iconPath(name=''){
    let path = "";
    // Strona do prawidłowych ikonek !! Prosze ich używac !! ===> https://heroicons.com/
    switch(name) {
        case 'phone':
            path = '<path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />';
            break;
        case 'cart':
            path = '<path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />';
            break;
        case 'arrow-right':
            path = `<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />`;
            break;
        case 'arrow-left':
            path = `<path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />`;
            break;
        case 'arrow-long-right':
            path = `<path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />`;
            break;
        case 'geo':
            path = `<path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />`;
            break;
        case 'user-group':
            path = `<path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />`;
            break;
        case 'chat':
            path = `<path fill-rule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clip-rule="evenodd" />`;
            break;
        case 'email' :
            path = `<path fill-rule="evenodd" d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z" clip-rule="evenodd" />`;
            break;
        case 'check':
            path = `<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />`;
            break;
        case 'selector':
            path = `<path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />`;
            break;
        case 'chart-bar':
            path = `<path  d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />`;
            break;
        case 'user':
            path = `<path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />`;
            break;
        case 'x':
            path = `<path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />`;
            break;
        case 'server':
            path = `<path fill-rule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z" clip-rule="evenodd" />`;
            break;
        case 'paper-clip':
            path = `<path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />`;
            break;
        case 'x-circle':
            path = `<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />`;
            break;
        case 'plus-circle':
            path = `<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />`;
            break;
        case 'currency-dolar':
            path = `<path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd" />`;
            break;
        case 'cash':
            path = `<path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />`;
            break;
        case 'pencil':
            path = '<path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />';
            break;
        case 'image':
            path = `<path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" />`;
            break;
        case 'settings':
            path = `<path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />`;
            break;
        case 'save':
            path = `<path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />`;
            break;
        case 'plus':
            path = `<path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />`;
            break;
        case 'trash':
            path = `<path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />`;
            break;
        case 'logout':
            path = `<path fill-rule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clip-rule="evenodd" />`;
            break;
        case 'truck':
            path = `<path fill-rule="evenodd" d="M11.5 4a.5.5 0 0 1 .5.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-4 0 1 1 0 0 1-1-1v-1h11V4.5a.5.5 0 0 1 .5-.5zM3 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm1.732 0h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4a2 2 0 0 1 1.732 1z" clip-rule="evenodd"/>`;
            break;
        case 'calendar':
            path = `<path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />`;
            break;
        case 'clock':
            path = `<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />`;
            break;
        case 'question':
            path = `<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />`;
            break;
        case 'download':
            path = `<path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />`;
            break;
        case 'users':
            path = `<path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />`;
            break;
        case 'minus':
            path = `<path fill-rule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />`;
            break;
        case 'globe':
            path = `<path fill-rule="evenodd" d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z" clip-rule="evenodd" />`;
            break;
        case 'fb':
            path = `<path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>`;
            break;
        default:
            path = '<path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>';
            break;
    }

    return path;
}
export function getValue(arr, value, defaultVal = null) {
    return arr ? value : defaultVal;
}
export function getLangImage(lang) {
    return '/img/lang/' + lang + '.svg'
}
export function linkGenerate(slug, text, options){
    let link = '<a target="' + (options && options.blank ? '_blank' : '_self') + '" class="text-red-700 hover:underline" href=' + route('page.show', slug) + '>' + text + '</a>';
    return link;
}
export function isAdmin(user) {
    if(user && user.type == 'admin') return true;
    else return false;
}
export function getPrice(value, currency = null, free = true) {
    let locale = currency ? currency : usePage().props.value.locale;

    if(value > 0){
        return value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) + ' ' + ( (locale == 'pl' || locale == 'PLN') ? '€' : '€');
    }
    else return free ? 'Free' : 0;
}
export function getPackagePrice(arr, key = 0) {
    let array = unserialize(arr);

    return getPrice( array[key].price );
}
export function getPieces(item, html = true, perOne = false) {
    let amount = perOne ? 1 : item.amount;

    let product = item.product ? item.product : item.product_details.product;

    let pieces = `<span>` + ( product.pieces_type == 'pieces' ? (product.quantity * amount) : (item.count ? (item.count.quantity * amount) : 0) ) + `</span>`;

    if(product.pieces_type == 'pieces' && item.count)
        pieces += `<span class="text-red-700 pl-1">+` + (item.count.quantity * amount) + `</span>`;


    return html ?
        pieces : (product.pieces_type == 'pieces' ?
                    (product.quantity * amount) : (item.count.quantity * amount)) + (product.pieces_type == 'pieces' && item.count ?
                        (' +' + (item.count.quantity * amount) ) : '');
}
export function getOriginalPrice(item){
    let price = 0;
    let product = item.product ? item.product : item.product_details.product;

    if(product.pieces_type != 'packages') price = Number(product.price) + (item.count ? Number(item.count.price) : 0);
    else price = Number(item.count.price);

    return price;
}
export function getTotalPerProduct(item, currency = true, coupon) {
    let piecesPrice = 0;
    let user = usePage().props.value.auth.user;
    let product = item.product ? item.product : item.product_details.product;


    if(product.pieces_type != 'packages')
        piecesPrice = Number(product.price) + (item.count ? Number(item.count.price) : 0);
    else
        piecesPrice = Number(item.count ? item.count.price : 0);

        piecesPrice *= item.amount;

    if(user.coupon && !coupon && user.coupon.discount_type == 'product') {
        if(user.coupon.products.find(element => element.id == item.product_id)){
            piecesPrice = calcDiscount(user.coupon.value, piecesPrice);
        }
    }
    else if(coupon && !user.coupon && coupon.discount_type == 'product') {
        if(coupon.products.find(element => element.id == item.product_id)){
            piecesPrice = calcDiscount(coupon.value, piecesPrice);
        }
    }
    else if(coupon && user.coupon && ( coupon.discount_type == 'product' || user.coupon.discount_type == 'product') ) {
        user.coupon.products.forEach(el => {
            if(
                coupon.products.find(element => element.id == el.id) &&
                coupon.products.find(element => element.id == item.product_id) &&
                user.coupon.products.find(element => element.id == item.product_id)
            ){
                let value = Number(user.coupon.value) + Number(coupon.value);
                piecesPrice = calcDiscount(value, piecesPrice);
            }
            else if(el.id == item.product_id) piecesPrice = calcDiscount(user.coupon.value, piecesPrice);
        });
        coupon.products.forEach(el => {
            if(
                !user.coupon.products.find(element => element.id == el.id) &&
                el.id == item.product_id
            ) piecesPrice = calcDiscount(coupon.value, piecesPrice);
        });
    }

    let result = null;
    result = ( currency ? getPrice(piecesPrice) : piecesPrice )

    item['total'] = piecesPrice;

    return result;
}
export function getTotalPrice(items, coupon, shipping) {
    let sum = 0;
    let origin = 0;
    let discountCart = 0;
    let user = usePage().props.value.auth.user;

    let u = user.coupon;
    let c = coupon;

    if(items){
        items.forEach(el => {
            if(u && c && c.discount_type == 'product' && u.discount_type == 'product') sum += getTotalPerProduct(el, false, coupon)
            else sum += getTotalPerProduct(el, false)
        });
    }
    origin = sum;
    let disc = 0;

    if(c && u && u.discount_type == 'cart' && coupon.discount_type == 'cart'){
        let value = Number(coupon.value) + Number(u.value)
        disc = calcDiscount(value, sum);
    }
    else {
        // && u.locale == usePage().props.value.locale
        if(u && u.discount_type == 'cart') disc = calcDiscount(u.value, sum);
        if(c && c.discount_type == 'cart') disc = calcDiscount(c.value, sum);
    }

    if(disc > 0) {
        discountCart = sum - disc;

        if(u && c && c.discount_type == 'product' && u.discount_type == 'cart')
            sum = origin - getCountDiscount(items, c, discountCart );
        else
            sum = disc;
    }
    else sum -= getCountDiscount(items, c, discountCart);


    let free_shipping = false;
    if( (shipping && usePage().props.value.locale != 'pl') || (shipping && shipping.price) ) {
        let price_free = shipping.price_free ? Number(shipping.price_free.value) : 0;
        if(price_free == 0 || ( sum < price_free) ) sum += Number(shipping.price ? shipping.price.value : 0);
        else free_shipping = true;
    }

    return {
        sum: sum,
        discountCart: discountCart,
        free_shipping: free_shipping
    };
}
export function getTotalPriceWithCount(product, count) {
    let price = 0;
    price = product.pieces_type != 'packages' ? Number(product.price) + ( count ? Number(count.price) : 0) : count ? count.price : 0

    return getPrice( price );
}
export function pricePerItem(item) {
    let product = item.product ? item.product : item.product_details.product;

    return getPrice(
        product.pieces_type == 'packages' ?
        product.price : Number(product.price) / product.quantity
    )
}
export function isEngrave(options, val) {
    let option = false;
    if(Array.isArray(val)){
        val.forEach(el => {
            if(options[el] == true || options[el] == '1' || options[el] == 'true') {
                option = true;
                return;
            }
        });
    }
    else if(options[val] == true) option = true;
    return option;
}
export function isTrue(val, a){
    if(val == true || val == '1' || val == 'true') return true;
}
export function sortProduct(product) {
    return product.sort((a, b) => Number(a.sort) - Number(b.sort));
}
export function getProductImage(images){
    return images.length ? ( images.find(el => el.sort === 1) ? images.find(el => el.sort === 1).link : images[0].link ) : '/img/cms/logo-color.png'
}
export function str_slug(text) {
    return text.replace(/[&\/\\#,+()$~%.'`=:;*?<>{}\[\]]/g, '').replace(/[_]/g, '-').toLowerCase().replace(/\s+/g, '-');
}
export function getCountDiscount(cart, coupon = null, discountCart){
    let user = usePage().props.value.auth.user;
    let price = 0;
    let value = 0;

    cart.forEach(el => {
        let disc = 0;
        let calc = false;

        if(!user.coupon && coupon && coupon.products.find(element => element.id == el.product_id) && coupon.discount_type == 'product') {
            value = Number(coupon.value);
            calc = true;
        }
        if(!coupon && user.coupon && user.coupon.products.find(element => element.id == el.product_id) && user.coupon.discount_type == 'product') {
            value = Number(user.coupon.value);
            calc = true;
        }

        if(user.coupon && coupon) {
            if(coupon.discount_type == 'product' || user.coupon.discount_type == 'product'){
                user.coupon.products.forEach(product => {
                    if(
                        coupon.products.find(element => element.id == product.id) &&
                        coupon.products.find(element => element.id == el.product_id) &&
                        user.coupon.products.find(element => element.id == el.product_id)
                    ) {
                        calc = true;
                        value = Number(user.coupon.value) + Number(coupon.value);
                    }
                    else if(product.id == el.product_id) {
                        value = Number(user.coupon.value);
                        calc = true;
                    }
                });
                coupon.products.forEach(product => {
                    if(
                        !user.coupon.products.find(element => element.id == product.id) &&
                        product.id == el.product_id
                    ) {
                        value = Number(coupon.value);
                        calc = true;
                    }
                });
            }
        }

        if(calc) {
            if(el.product.pieces_type != 'packages') disc = getOriginalPrice(el);
            else disc = Number(el.count.price);
        }


        if(disc > 0){
            let discount = disc * (value / 100);
            price += discount;
        }
    });

    if(discountCart > 0) price += discountCart;
    return price;
}

export function getOrderPrice(item, coupon) {
    let count = 0;

    item.forEach(el => {
        count += getTotalPerProduct(el, false, coupon);
    });

    return getPrice(count);
}
export function getDiscount(coupon = null, user = null) {
    let discount = 0;
    let value = 0;

    if(coupon && !user) value = Number(coupon.value);
    else if(user && !coupon) value = Number(user.coupon.value);
    else if(user && coupon) value = Number(user.coupon.value) + Number(coupon.value)

    discount = Number(value);
    discount += ' %'

    return '-' + discount;
}
export function calcDiscount(value = 0, price){
    let discount = price * (Number(value) / 100);
    price -= discount;

    return price;
}
export function countDiscount(coupon, price) {
    let discount = price * (Number(coupon.value) / 100);
    price += discount;

    return price;
}
export function getCurrency() {
    let locale = usePage().props.value.locale;
    return locale == 'pl' ? ' €' : ' €'
}

// time
export function getFullTime(date = null, format = null) {
    return moment( date ? date : new Date(), 'YYYY-MM-DD HH:mm:ss' ).format(format ? format : 'HH:mm:ss');
}
export function getDate(date = null, format = null) {
    return moment( date ? date : new Date(), 'YYYY-MM-DD' ).format(format ? format : 'DD-MM-YYYY');
}
export function getYear(date = null, format = null) {
    return moment( date ? date : new Date(), 'YYYY-MM-DD' ).format(format ? format : 'YYYY');
}
export function getDateWithTime(date = null, format = null) {
    return moment( date ? date : new Date(), 'YYYY-MM-DD HH:mm:ss' ).format(format ? format : 'DD-MM-YYYY HH:mm:ss');
}
export function getDateEndOf(date = null) {
    return moment(date ? date : new Date(), 'YYYY-MM-DD').endOf('day').fromNow();
}
export function isAfterDate(date = null) {
    return moment( new Date() ).isAfter(date, 'day');
}
